import './index.scss'

function CustomLoader() {
  return (
    <div className="app-fullscreen-loader-container">
      <span className="app-fullscreen-loader"></span>
    </div>
  )
}

export default CustomLoader
